import { useState } from "react";
import { Map, Pencil, Printer, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { LineupField, exportLineupCard, offField } from "@/lib/lineup";

const FieldDialog = ({ cfg, lineup, onClose }) => (
  <Dialog open onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-3xl" data-testid="lineup-field-dialog">
      <DialogHeader><DialogTitle className="font-heading text-2xl uppercase">{lineup.name}</DialogTitle></DialogHeader>
      <div className="field-frame"><LineupField cfg={cfg} lineup={lineup} /></div>
      {offField(lineup).length > 0 && (
        <p className="text-sm font-semibold" data-testid="lineup-off-field">
          Off the field: {offField(lineup).map((e) => `${e.name} (${e.position})`).join(", ")}
        </p>
      )}
    </DialogContent>
  </Dialog>
);

export const LineupCard = ({ lineup, cfg, teamName, onEdit, onDelete }) => {
  const [showField, setShowField] = useState(false);
  const print = async () => {
    const t = toast.loading("Building lineup card...");
    try {
      await exportLineupCard(lineup, cfg, teamName);
      toast.success("Lineup card downloaded", { id: t });
    } catch {
      toast.error("Could not build the lineup card", { id: t });
    }
  };
  return (
    <div className="card space-y-3" data-testid="lineup-card">
      <div className="flex items-start justify-between gap-2">
        <h3 className="font-heading text-2xl font-extrabold uppercase leading-tight" data-testid="lineup-card-name">{lineup.name}</h3>
        {onEdit && (
          <div className="flex gap-1.5">
            <button className="icon-btn !min-h-[40px] !min-w-[40px]" data-testid="lineup-edit-button" onClick={onEdit} aria-label="Edit lineup"><Pencil size={16} /></button>
            <button className="icon-btn !min-h-[40px] !min-w-[40px]" data-testid="lineup-delete-button" onClick={onDelete} aria-label="Delete lineup"><Trash2 size={16} /></button>
          </div>
        )}
      </div>
      <ol className="space-y-1">
        {lineup.entries.map((e, i) => (
          <li key={i} className="flex items-center gap-3 font-semibold">
            <span className="w-6 text-right font-heading text-lg font-extrabold">{i + 1}</span>
            <span className="flex-1 truncate">{e.name}</span>
            <span className="chip !text-xs">{e.position}</span>
          </li>
        ))}
      </ol>
      {lineup.notes && <div className="staff-callout" data-testid="lineup-notes"><span><b>Coaches:</b> {lineup.notes}</span></div>}
      <div className="flex gap-2">
        <button className="btn-ghost flex-1 !text-base" data-testid="lineup-field-button" onClick={() => setShowField(true)}><Map size={18} /> Field view</button>
        <button className="btn-ghost flex-1 !text-base" data-testid="lineup-print-button" onClick={print}><Printer size={18} /> Print card</button>
      </div>
      {showField && <FieldDialog cfg={cfg} lineup={lineup} onClose={() => setShowField(false)} />}
    </div>
  );
};
